import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../../core/pagination/datatable.jsx";

import {
  ROLL_CALL_API_BASE_URL,
  ROLL_CALL_BULK_ATTENDANCE,
  ROLL_CALL_GET_MY_TEAM,
} from "../../RollCallConfig/RollCallConfig.js";
import { Spin } from "antd";
import Swal from "sweetalert2";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CommonFooter from "../../../../../core/common/footer/commonFooter.jsx";

const BulkAttendance = () => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setloading] = useState(false);
  const [startDateTime, setStartDateTime] = useState("");
  const [endDateTime, setEndDateTime] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const navigate = useNavigate();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    const isManager = sessionStorage.getItem("isManager");

    if (isManager === "false") {
      alert("You don't have access to this page.");
      sessionStorage.clear();
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    setloading(true);

    if (tokenData && superIdData) {
      fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_GET_MY_TEAM}?managerid=${regId}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          if (data && data.status) {
            setTeamMembers(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setTeamMembers([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setloading(false);
        });
    }
  }, [superIdData, tokenData]);

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [regIds, setRegId] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const handleHeaderCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      const allKeys = teamMembers.map((item) => item.CardId);
      const formatted = teamMembers.map((item) => ({
        CardId: item.CardId,
        RegId: item.CardId,
        UserName: item.UserName,
      }));
      setSelectedRowKeys(allKeys);
      setRegId(formatted);
    } else {
      setSelectedRowKeys([]);
      setRegId([]);
    }
  };

  const handleRowCheckboxChange = (e, record) => {
    const isChecked = e.target.checked;
    let updatedKeys = [...selectedRowKeys];
    let updatedRegIds = [...regIds];

    if (isChecked) {
      updatedKeys.push(record.CardId);
      updatedRegIds.push({
        CardId: record.CardId,
        RegId: record.CardId,
        UserName: record.UserName,
      });
    } else {
      updatedKeys = updatedKeys.filter((key) => key !== record.CardId);
      updatedRegIds = updatedRegIds.filter(
        (item) => item.CardId !== record.CardId
      );
    }

    setSelectedRowKeys(updatedKeys);
    setRegId(updatedRegIds);
    setSelectAll(updatedKeys.length === teamMembers.length);
  };

  const handleCardCheckboxChange = (e, record) => {
    const updatedKeys = selectedRowKeys.filter((key) => key !== record.CardId);
    const updatedRegIds = regIds.filter(
      (item) => item.CardId !== record.CardId
    );
    setSelectedRowKeys(updatedKeys);
    setRegId(updatedRegIds);
    setSelectAll(updatedKeys.length === teamMembers.length);
  };

  const columns = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectAll}
          onChange={handleHeaderCheckboxChange}
          disabled={submitLoading}
        />
      ),
      dataIndex: "select",
      render: (_, record) => (
        <input
          type="checkbox"
          checked={selectedRowKeys.includes(record.CardId)}
          onChange={(e) => handleRowCheckboxChange(e, record)}
        />
      ),
    },
    {
      title: "Badge",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge.length - b.Badge.length,
    },

    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.length - b.UserName.length,
    },

    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation.length - b.Designation.length,
    },
  ];
  console.log(regIds);

  const handleSubmit = async () => {
    setSubmitLoading(true);
    const superid = superIdData;
    const MachineId = "99";
    const formatDateTime = (input) => {
      const date = new Date(input);
      const pad = (n) => n.toString().padStart(2, "0");
      return (
        `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(
          date.getDate()
        )}` + ` ${pad(date.getHours())}:${pad(date.getMinutes())}:00`
      );
    };

    const formattedRegIds = `[${regIds
      .map((r) => `{ 'CardId': '${r.CardId}', 'RegId': '${r.RegId}' }`)
      .join(",")}]`;
    const formattedStart = formatDateTime(startDateTime);
    const formattedEnd = formatDateTime(endDateTime);

    const payload = {
      superid: superid,
      MachineId: MachineId,
      startdatetime: formattedStart,
      enddatetime: formattedEnd,
      regids: formattedRegIds,
    };
    console.log(JSON.stringify(payload), "payload");

    try {
      const response = await fetch(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_BULK_ATTENDANCE}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "API request failed");
      }

      const data = await response.json();

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Attendance submitted successfully!",
      }).then(() => {
        window.location.reload();
      });

      console.log("Success:", data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.message || "Something went wrong",
      });

      console.error("Error:", error);
    }
    setSubmitLoading(false);
  };

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="page-wrapper pt-5">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Bulk Attendance
                    </h4>
                  </ol>
                </nav>
                <h6>All Attendance, One Go</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li onClick={() => window.location.reload()}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          {/* /product list */}
          <div className="row ">
            <div className="col-6">
              <div className="card table-list-card ">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <div className="search-set p-3"></div>
                </div>
                <div className="card-body pb-0">
                  <div className="table-responsive">
                    {loading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p>Loading data...</p>
                      </div>
                    ) : teamMembers.length > 0 ? (
                      <Table columns={columns} dataSource={teamMembers} />
                    ) : (
                      <p className="text-center my-4">No data available</p>
                    )}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3 d-flex">
              <div className="card flex-fill">
                <div className="card-header p-3 fw-bold">
                  <i className="fa-solid fa-list-check me-2"></i> Selected Team
                  members
                </div>
                <div
                  className="card-body p-2"
                  style={{
                    minHeight: "6px",
                    maxHeight: "536px",
                    overflowY: "auto",
                  }}
                >
                  {regIds.length === 0 ? (
                    <div className="m-2 text-muted">
                      Selected employees will appear here
                    </div>
                  ) : (
                    regIds.map((record) => (
                      <div key={record.CardId} className="m-2">
                        <label>
                          <input
                            type="checkbox"
                            checked={true}
                            onChange={(e) =>
                              handleCardCheckboxChange(e, record)
                            }
                            className="me-2"
                            disabled={submitLoading}
                          />
                          <span>{record.UserName}</span>
                        </label>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
            <div className="col-3">
              <div className="card">
                <div className="card-header fw-bold text-gray">
                  <i className="fa-solid fa-wrench me-2"></i> Update Attendance
                </div>
                <div className="card-body">
                  <div className="mb-2">
                    <label className="form-label">Start Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={startDateTime}
                      onChange={(e) => setStartDateTime(e.target.value)}
                    />{" "}
                  </div>
                  <div className="mb-2">
                    <label className="form-label">End Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={endDateTime}
                      onChange={(e) => setEndDateTime(e.target.value)}
                    />{" "}
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    disabled={submitLoading}
                  >
                    {submitLoading ? "Submitting..." : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default BulkAttendance;
